import { render, staticRenderFns } from "./PremiumMetaData.vue?vue&type=template&id=10f9db75&lang=html&"
import script from "./PremiumMetaData.vue?vue&type=script&lang=js&"
export * from "./PremiumMetaData.vue?vue&type=script&lang=js&"
import style0 from "./PremiumMetaData.vue?vue&type=style&index=0&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports